import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const handleScrollToWork = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const element = document.getElementById('work');
    if (element) {
      const offset = 80;
      const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  return <section id="hero" className="min-h-screen flex flex-col justify-center px-6 md:px-12 pt-32 pb-24" data-id="element-127">
      <div className="max-w-6xl mx-auto w-full" data-id="element-128">
        <div className="flex flex-col-reverse lg:flex-row lg:items-center lg:gap-16 mb-20" data-id="element-129">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="lg:flex-1" data-id="element-130">
            <h1 className="text-6xl sm:text-7xl md:text-8xl lg:text-9xl font-bold text-primary leading-[1.05] tracking-tight mb-8" data-id="element-131">
              Karan Dhir
            </h1>

            <h2 className="text-2xl md:text-3xl text-primary font-medium tracking-tight mb-6 max-w-2xl leading-snug" data-id="element-132">
              I build the measurement and decision systems that make marketing
              AI trustworthy enough to act on.
            </h2>

            <p className="text-secondary text-lg md:text-xl max-w-2xl leading-relaxed mb-10" data-id="element-133">
              Marketing mix modeling, incrementality, and causal inference.
              Turning billion-dollar spend questions into decisions leaders
              actually trust.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-134">
              <a href="#work" onClick={handleScrollToWork} className="inline-flex items-center justify-center px-8 py-4 text-sm font-semibold text-dark bg-gold hover:bg-gold-hover rounded-full transition-colors w-full sm:w-auto" data-id="element-135">
                View Selected Work
              </a>
              <a href="https://www.linkedin.com/in/dhirkaran/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 text-sm font-semibold text-primary border border-border hover:border-gold hover:text-gold rounded-full transition-colors w-full sm:w-auto" data-id="element-136">
                Connect on LinkedIn
              </a>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.15,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex justify-center mb-12 lg:mb-0 shrink-0" data-id="element-137">
            <img src="https://cdn.magicpatterns.com/uploads/wjewJy4h9doZeRxAp9y6hv/Headshot.jpg" alt="Karan Dhir" className="w-56 h-56 md:w-72 md:h-72 rounded-2xl object-cover border border-border shadow-lg shadow-black/30" data-id="element-138" />
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }} className="pt-10 border-t border-border/50" data-id="element-139">
          <div className="text-xs font-medium text-secondary/70 uppercase tracking-widest mb-6" data-id="element-140">
            Genentech • Amazon • Walmart
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-141">
            {['$1.2B+ in annual marketing spend directed by the MMM I own', '17+ oncology, immunology and neurology brands', "First pharmaceutical team on Google's Meridian", 'Killed a multimillion-dollar AI initiative the measurement did not justify'].map((stat, i) => <div key={i} className="glass-card p-5 rounded-xl flex items-center h-full" data-id="element-142">
                <span className="text-sm font-medium text-primary leading-snug" data-id="element-143">
                  {stat}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}